import axios from 'axios'

// Pour le  /session/ (sans envoi de token)
export default() => {
  return axios.create({
    baseURL: process.env.VUE_APP_API,
  })
}